"use strict";


import $ from 'jquery';
import 'magnific-popup';
import 'magnific-popup/dist/magnific-popup.css';
import './modal.css';


var mfpArgs = {
		removalDelay: 300,
		mainClass: 'mfp-fade',
		fixedContentPos: true,
		tClose: 'Fechar (tecla Esc)',
		tLoading: 'Carregando...',
		gallery: {
			enabled: false,
			arrowMarkup: '<button type="button" class="slick-arrow slick-arrow-%dir%"><i class="fa fa-angle-%dir%"></i></button>',
			tPrev: 'Anterior (seta para esquerda)',
			tNext: 'Próximo (seta para a direita)',
			tCounter: '%curr% de %total%'
		},
		callbacks: {
			// beforeOpen: mfpBeforeOpen,
			open: mfpOnOpen,
			afterClose: mfpOnClose,
		}
	};


(function () {

	magnificPopupConfig();

	// modalPostSingleConfig();

})();


function magnificPopupConfig() {

	var args = mfpArgs,
		els = document.querySelectorAll('a.mfp');

	if (els.length) {
		$(els).magnificPopup(args);
	}

	// args = mfpArgs;
	// args.type = 'inline';
	// $('a[href^="#"]').magnificPopup(args);

	// args = mfpArgs;
	// args.type = 'image';
	// $('a[href$=".jpg"], a[href$=".png"]', '.entry-content').magnificPopup(args);

	args = mfpArgs;
	args.type = 'image';
	args.gallery.enabled = true;
	els = document.querySelectorAll('.carsl-item a[href$=".jpg"], .carsl-item a[href$=".png"]');
	if (els.length) {
		$(els).magnificPopup(args);
	}

	// $('a[href$=".jpg"], a[href$=".png"]', '.entry-content').on('click', function(e) {
	// 	e.preventDefault();

	// 	if ($.magnificPopup.instance.isOpen) {
	// 		$.magnificPopup.instance.close();
	// 	}

	// 	setTimeout(() => {
	// 		args = mfpArgs;
	// 		args.type = 'image';
	// 		args.items = {
	// 			src: $(this)[0].getAttribute('href')
	// 		};
	// 		$.magnificPopup.open(args);
	// 	}, 400);
	// });

	// args = mfpArgs;
	// args.type = 'iframe';
	// $('.play-trg').magnificPopup(args);

}


// function mfpBeforeOpen() {

// 	$.magnificPopup.instance.close();

// }


function mfpOnOpen() {

	document.body.classList.add('modal-opened');

	$('.modal-close-trg').on('click', function() {
		$.magnificPopup.instance.close();
	});

}


function mfpOnClose() {

	// var videoEl = document.getElementById('conceito-video');
	// if (!videoEl.paused) {
	// 	videoEl.pause();
	// }

	document.body.classList.remove('modal-opened');
	// document.body.removeAttribute('data-modal');

}


function mfpChange() {

	// $('.hero').slick('slickGoTo', $.magnificPopup.instance.index - 1);

}


// function modalPostSingleConfig() {

// 	var els = document.querySelectorAll('.historia[data-id]');
// 	for (var i = 0; i < els.length; i++) {
// 		var el = els[i];

// 		el.addEventListener('click', modalPostSingleShow);
// 	}

// }


// function modalPostSingleShow(e) {

// 	"use strict";

// 	e.preventDefault();
// 	e.stopPropagation();

// 	var el = e.target;

// 	while (el.getAttribute('data-id') == null) {
// 		el = el.parentNode;
// 	}

// 	var postId = el.getAttribute('data-id'),
// 		postVideo = el.getAttribute('data-video'),
// 		url = jtVars.templateDirectory + '/lib/requests/single.php',
// 		args = mfpArgs;

// 	if (postVideo) {
// 		args.items = {
// 			src: postVideo,
// 			type: 'iframe',
// 		}
// 		$.magnificPopup.open(args);
// 	} else {
// 		$.ajax({
// 			type: 'get',
// 			dataType: 'html',
// 			url: url,
// 			data: { postId: postId },
// 			beforeSend: function() {
// 				el.setAttribute('data-loading', 0);
// 			},
// 			success: function (data, status, xhr) {
// 				args.items = {
// 					src: data,
// 					type: 'inline',
// 				}
// 				$.magnificPopup.open(args);
// 			},
// 			complete: function (xhr, status) {
// 				el.setAttribute('data-loading', 0);
// 			}
// 		});
// 	}

// }



// WEBPACK FOOTER //
// ./js/modal.js